<template>
  <!-- 问答题 -->
  <yxt-form
    ref="ruleForm"
    :model="currentComponent"
    label-width="100px"
    isNeedRequire
    isNeedTooltip
    label-position="top"
    size="small"
  >
    <yxt-form-item
      :label="$t('pc_biz_ote_lbl_questionstem')"
      prop="content"
      :rules="rulesContent"
      size="small"
    >
      <common-attachment-textfield
        :content.sync="currentComponent.content"
        single-limit
      />
    </yxt-form-item>
    <!-- 答案描述 -->
    <yxt-form-item
      :label="$t('pc_biz_ote_lbl_itemanswer')"
      size="small"
      prop="answerContent"
    >
      <common-attachment-textfield
        :content.sync="currentComponent.answerContent"
        single-limit
      />
    </yxt-form-item>
    <div class="yxtbiz-ote-edit-ques-kw mb24">
      <yxt-form-item
        v-for="(item, index2) in currentComponent.keywords"
        :key="index2"
        label=""
        size="small"
        :class="{
          'mb8': (currentComponent.keywords.length - 1) === index2
        }"
      >
        <div class="flex">
          <span>
            {{ $t('pc_biz_ote_keyword') }}
            <span class="min-w-16 d-in-block">{{ index2 + 1 }}</span>
          </span>
          <yxt-form-item
            :prop="'keywords.' + index2 + '.name'"
            :rules="rulesName"
            size="small"
            class="ml4 mr24"
          >
            <yxt-input
              :ref="'editorItem_input' + index2"
              v-model="item['name']"
              maxlength="30"
            ></yxt-input>
          </yxt-form-item>
          <span>{{ $t('pc_biz_ote_lbl_scorerate') }}</span
          ><yxt-form-item
            :prop="'keywords.' + index2 + '.rate'"
            :rules="rulesRate"
            size="small"
            class="ml8"
          >
            <div class="flex">
              <yxt-input-number
                v-model="item['rate']"
                controls-position="right"
                :min="1"
                :max="100"
                class="mr8"
                @blur="setScore(item)"
              >
              </yxt-input-number>
              <span class="shortanswer_score">%</span>
              <div class="flex flex-mid">
                <yxt-tooltip
                  :content="$t('pc_biz_ote_btn_delete')"
                  placement="top"
                >
                  <div
                    class="yxtbiz-ote-ai-icon hand ml12 color-gray-8"
                    @click="delItem(index2)"
                  >
                    <yxt-svg width="16px" height="16px" icon-class="delete" />
                  </div>
                </yxt-tooltip>
              </div>
            </div>
          </yxt-form-item>
        </div>
      </yxt-form-item>
      <!-- 添加选项 -->
      <div>
        <yxt-button
          type="text"
          @click="addItem()"
          :disabled="
            currentComponent.keywords && currentComponent.keywords.length >= 10
          "
        >
          <div class="flex flex-mid">
            <yxt-svg
              width="16px"
              height="16px"
              class="mr4"
              icon-class="common_plus"
            ></yxt-svg>
            <span>{{ $t('pc_biz_ote_btn_addnewkeyword') }}</span>
          </div>
        </yxt-button>
      </div>
    </div>
    <yxt-form-item
      :label="$t('pc_biz_ote_lbl_quesanalyze')"
      size="small"
      prop="explainText"
    >
      <common-attachment-textfield
        :content.sync="currentComponent.explainText"
        single-limit
      />
    </yxt-form-item>
  </yxt-form>
</template>

<script>
import { quesMixin } from './quesMixin';
import CommonAttachmentTextfield from './components/CommonAttachmentTextfield.vue';
import { getSafeHtmlContent } from '../../utils';
import { SvgMediaNewUrl } from '../../const';

export default {
  name: 'quesShortAnswer',
  mixins: [quesMixin],
  components: {
    CommonAttachmentTextfield
  },
  mounted() {
    this.getDetail();
  },
  data() {
    return {
      SvgMediaNewUrl,
      rulesContent: {
        required: true,
        message: this.$t('pc_biz_ote_msg_pleaseenterquestion'),
        trigger: 'blur'
      },
      rulesName: {
        trigger: 'blur',
        validator: (rule, value, callback) => {
          if (!value) {
            callback(new Error(this.$t('pc_biz_ote_msg_keyword')));
            return;
          }
          if (
            this.currentComponent.keywords
              .map(item => item.name)
              .lastIndexOf(value) !==
            this.currentComponent.keywords.map(item => item.name).indexOf(value)
          ) {
            callback(new Error(this.$t('pc_biz_ote_msg_keywordsnotrepeated')));
            return;
          }
          callback();
        }
      },
      rulesRate: {
        trigger: 'blur',
        validator: (rule, value, callback) => {
          if (Number(value) < 1) {
            callback(new Error(this.$t('pc_biz_ote_msg_scoregreater')));
            return;
          }
          const count = this.currentComponent.keywords.reduce(
            (item, count2) => {
              return Number(count2.rate) + item;
            },
            0
          );
          if (count > 100) {
            callback(new Error(this.$t('pc_biz_ote_msg_summax')));
            return;
          }
          callback();
        }
      }
    };
  },
  methods: {
    setScore(val, e) {
      val.rate = parseInt(Math.abs(val.rate || 1), 10);
    },
    // 获取试题基本信息
    getDetail() {
      try {
        this.$refs['content' + this.index].setHtml(
          this.currentComponent.content
        );

        this.$refs['explainText' + this.index].setHtml(
          this.currentComponent.explainText
        );
      } catch (e) {}
    },
    // 保存试题基本信息
    saveDetail() {
      // 编辑试题
      let isSave = false;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          isSave = true;
        } else {
          return false;
        }
      });
      if (!isSave) {
        return { error: true };
      } else {
        this.currentComponent.summary = getSafeHtmlContent(this.currentComponent.content);
        this.currentComponent.keywords = this.currentComponent.keywords || [];
        delete this.currentComponent.questionItems;
        this.currentComponent.error = 0;
        this.currentComponent.errorMsg = '';
        return this.currentComponent;
      }
    },
    // 删除
    delItem(index) {
      this.currentComponent.keywords.splice(index, 1);
    },
    // 添加选项
    addItem() {
      if (!this.currentComponent.keywords) {
        this.currentComponent.keywords = [];
      }
      if (this.currentComponent.keywords.length >= 10) {
        this.$message({
          type: 'warning',
          message: this.$t('pc_biz_ote_msg_keywordmax', [10]) // 10个关键字
        });
        return;
      }
      // 添加选项（单选/多选）
      const questionItem = {
        name: this.$t('pc_biz_ote_keyword'),
        rate: ''
      };
      this.currentComponent.keywords.push(questionItem);
      // focus到最后添加的输入框
      this.$nextTick(() => {
        this.$refs[
          `editorItem_input${this.currentComponent.keywords.length - 1}`
        ][0].focus();
        this.$refs[
          `editorItem_input${this.currentComponent.keywords.length - 1}`
        ][0].select();
      });
    }
  }
};
</script>
